export default "__VITE_ASSET__bb6bd8e6__"